import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserRepo } from 'src/app/repositories/user-repo';
import { SingleDiffusionList } from 'src/swagger-gen/web-secured/models';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-modal-delete-diffsion-list',
    templateUrl: './modal-delete-diffsion-list.component.html',
    styleUrls: ['./modal-delete-diffsion-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteDiffusionListComponent implements OnDestroy {

  loading = false;
  deleteSuccess: any;
  deleteError: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public diffList: SingleDiffusionList,
    private userRepo: UserRepo,
    private translate: TranslateService
  ) { }

  deleteDiffusionList() {
    this.loading = true;
    this.userRepo
      .deleteDiffusionList(this.diffList.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('administration.liste_deleted');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('administration.error_list_deleted');
        });
  }

  ngOnDestroy(): void {
  }
}
